import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { router } from '@src/router/index';
import { isNavigationFailure } from 'vue-router';
import { useStoreUser } from '@src/store/modules/user';
import { useStoreCity } from '@src/store/modules/city';

router.beforeEach(async (to, _from, next) => {
    NProgress.start();

    const storeUser = useStoreUser();
    const storeCity = useStoreCity();

    if (to.query.token) {
        storeUser.auth.token = to.query.token as string;
    }
    if (!to.meta.whiteList) {
        if (!storeUser.auth.token) return next({ name: 'Login', replace: true });
        if (!Object.keys(storeUser.user).length) await storeUser.getUser();
        if (storeUser.user.userId) await storeCity.initializeCityData(storeUser.user.userId);
    }
    next();
});

router.afterEach((_to, _from, failure) => {
    NProgress.done();
    if (isNavigationFailure(failure)) {
        console.error('路由错误啦', failure);
    }
});
